import React from "react";

import { useTranslation } from "utils";

import { Col, MainPage, Row, Svg } from "components";

export const Offline = () => {
  const { t } = useTranslation(["meta"]);

  return (
    <MainPage pageName={"sign-in-up"} className="page splash padding-0">
      <section className="container">
        <Row justify="space-around" align="middle" className="mini-form full-height">
          <Col className="center">
            <Svg svgName="logos/klim_logo_brandmark_and_text_white" className="pulsating" />
            <h5 className="white-text margin-top-200">{t("errors.offline")}</h5>
          </Col>
        </Row>
      </section>
    </MainPage>
  );
};
